import { Component, OnInit, ViewChild  } from '@angular/core';
import { ExceluploadService } from './_service/excelupload.service';
import { ExcelService } from './../excelservices/excel.service';
import * as XLSX from 'xlsx';
interface USERS {
  stateCode: String;
  costCenterDesc: String;
  costCenterFo: String;
}

@Component({
    selector: 'app-excel-upload',
    templateUrl: './excel-upload.component.html',
    styleUrls: ['./excel-upload.component.scss']
})
/** ExcelUpload component*/
export class ExcelUploadComponent implements OnInit {

  model: any = {};
  @ViewChild('inputyear') inputyear;
  @ViewChild('inputmonth') inputmonth;
  @ViewChild('tblexp1') tblExpense1;
  @ViewChild('getdata') getdata1;
  @ViewChild('gettable') gettable;

  expense1: any;
  expense2: any;
  data: any;
  Users: any[] = [];
  constructor(private _service: ExceluploadService, private _excelservice: ExcelService) { }


  ngOnInit() {
    $(".loader-mn").hide();
  }
  onSave(Year: string){
    debugger;
    

    

     
    this.OnYearChange(Year);

    

  
  }

  OnYearChange(Year)
  {
    debugger;
    this._service.getdatadown(Year).subscribe
        (res => {
        if (res) {
          debugger;
          this.expense1 = res;
          this.OnYearChange1(Year);

          }
        });
    
  }
  OnYearChange1(Year) {
    debugger;
    this._service.getdatadown(Year).subscribe
      (res => {
        if (res) {
          debugger;
          this.expense2 = res;
          this.exportAsXLSX();

        }
      });

  }

  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      debugger;
      console.log(this.data);
    };
    reader.readAsBinaryString(target.files[0]);
  }



  exportAsXLSX(): void {
    this._excelservice.exportAsExcelFile('Exceltable', 'Marketing_Cost');
  }
  clear() {
    window.location.reload();
  }

  save(Year1: string, Month1: string) {
   
    $(".loader-mn").show();
    var arrData = [];
    // loop over each table row (tr)
    $("#Exceltable tr").each(function () {
      var currentRow = $(this);
    
      var col1_value = currentRow.find("td:eq(0)").text();
      var col2_value = currentRow.find("td:eq(1)").text();
      var col3_value = currentRow.find("td:eq(2)").text();
      var col4_value = currentRow.find("td:eq(3)").text();
      var col5_value = currentRow.find("td:eq(4)").text();
      var col6_value = currentRow.find("td:eq(5)").text();
      var col7_value = currentRow.find("td:eq(6)").text();
      var col8_value = currentRow.find("td:eq(7)").text();
      var col9_value = currentRow.find("td:eq(8)").text();
      var col10_value = currentRow.find("td:eq(9)").text();
      var col11_value = currentRow.find("td:eq(10)").text();
      var col12_value = currentRow.find("td:eq(11)").text();
      var col13_value = Year1;
      var col14_value = Month1;

      var obj = {
        State: '',
        CostCenterFo: '',
        CostCenterDesc: '',
        val10: '',
        val20: '',
        val30: '',
        val40: '',
        val50: '',
        val60: '',
        val70: '',
        val80: '',
        val90: '',
        Year: '',
        month: ''



      };
      obj.State = col1_value;
      obj.CostCenterFo = col2_value;
      obj.CostCenterDesc = col3_value;
      obj.val10 = col4_value;
      obj.val20 = col5_value;
      obj.val30 = col6_value;
      obj.val40 = col7_value;
      obj.val50 = col8_value;
      obj.val60 = col9_value;
      obj.val70 = col10_value;
      obj.val80 = col11_value;
      obj.val90 = col12_value;
      obj.val90 = col12_value;
      obj.Year = col13_value;
      obj.month = col14_value;

      arrData.push(obj);
    });
  
   

    console.log(arrData);
    debugger;
    
    this._service.SaveData(arrData).subscribe
      (res => {
       
          alert('Data saved Successfully!');

        $(".loader-mn").hide();
      });

  

  }
 


  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
 
